import { createFileRoute } from "@tanstack/react-router";

import ReplacePage from "./-components/ReplacePage";

export const Route = createFileRoute("/_app/_dashboard/proxy/list/replace")({
  component: ReplacePage,
});
